import { Injectable } from "@angular/core";
import { KeycloakService } from "keycloak-angular";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn:'root'
})
export class AuthService{
    public authToken=new BehaviorSubject<Array<any>>([]);
    public userInfo=new BehaviorSubject<Array<any>>([]);
    public userRole=new BehaviorSubject<Array<any>>([]);
    constructor(private keycloakservice:KeycloakService){

    }
    getLoggedUser(){
        try{
            let userDetails= this.keycloakservice.getKeycloakInstance().idTokenParsed;
            return userDetails;
        }catch(e){
            return undefined;
        }
    }

    logout(){
        this.keycloakservice.logout();
    }
    redirectToProfile(){
        this.keycloakservice.getKeycloakInstance().accountManagement();
    }
    getRoles():string[]{
        return this.keycloakservice.getUserRoles();
    }

    public async getKeyCloackToken(type:string){
        if(!(this.getkeycloakAuthToken && this.getkeycloakAuthToken.length) || type=="New"){
        return await this.keycloakservice.getToken().then((tkn:any) => {
            return this.authToken.next(tkn);
            });
        }
        }
    public get getkeycloakAuthToken(){
        return this.authToken.getValue();
    }
    public async getKeyCloackUserInfo(type:string){  
        await this.getKeycloackUserProfile() 
        if(!(this.getkeycloakUserInfo && this.getkeycloakUserInfo.length) || type=="New"){
        return await  this.keycloakservice.getKeycloakInstance().loadUserInfo().then((tkn:any) => {
            return this.userInfo.next(tkn);
            });
        }
    }
    public get getkeycloakUserInfo(){
        return this.userInfo.getValue();
    }

    public async getKeycloackUserProfile(){
        this.keycloakservice.getKeycloakInstance().loadUserProfile().then((usr:any)=>{
        })
    }

}